// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import SideMenu from "@store/Library/Components/Toolkit/SideMenu";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { SideMenuPresentationProps } from "@store/Library/Components/Toolkit/SideMenu";
import getColor from "@insite/mobius/utilities/getColor";
import { IconWrapper } from "@insite/mobius/Icon";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import ChevronRight from "@store/Library/Components/Toolkit/Icons/ChevronRight";
/* Store Custom Code - End */

export interface AccountSideMenuStyles {
    wrapper?: InjectableCss;
    sideMenu?: SideMenuPresentationProps; // Store Custom Code
}

export const accountSideMenuStyles: AccountSideMenuStyles = {
    wrapper: {
        css: css`
            ${spacingStyles()}
            width: 100%;
        `,
    },
    // Store Custom Code
    sideMenu: {
        extendedStyles: {
            wrapper: {
                css: css`
                    background-color: ${getColor("common.accent")};
                    box-shadow: none;
                `,
            },
            list: {
                css: css`
                    font-size: ${x => x.theme.design.typography.size.base};
                `,
            },
            link: {
                css: css`
                    &:hover {
                        ${IconWrapper} {
                            color: ${getColor("primary")};
                        }
                    }
                `,
                icon: {
                    position: "right",
                    iconProps: {
                        src: ChevronRight,
                        color: "text",
                        css: css`
                            margin-left: ${pxToRem(10)};

                            &:hover {
                                color: ${getColor("primary")};
                            }
                        `,
                    },
                },
                typographyProps: {
                    css: css`
                        position: relative;
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                    `,
                },
            },
        },
    },
};

const styles = accountSideMenuStyles;

const AccountSideMenu: FC<WidgetProps> = () => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <SideMenu
                pageType={constants.pageType.myAccount}
                showRootPage
                showSignOut
                {...styles.sideMenu} // Store Custom Code
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: AccountSideMenu,
    definition: {
        group: "My Account",
        icon: "bars",
        displayName: "Account Menu",
    },
};

export default widgetModule;
